/**
 * Top-level error boundary.
 *
 * Catches render errors so a single broken component cannot leave the user
 * staring at a blank page.
 */

import { Component } from 'react';
import styles from './ErrorBoundary.module.css';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Render error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className={styles.container} role="alert">
        <div className={styles.card}>
          <h1 className={styles.title}>Something went wrong</h1>
          <p className={styles.message}>
            The page hit an unexpected error. Your saved songs and playlists are safe.
          </p>

          <div className={styles.actions}>
            <button type="button" className={styles.primary} onClick={this.handleReload}>
              Reload the page
            </button>
            <button type="button" className={styles.secondary} onClick={this.handleReset}>
              Try again
            </button>
          </div>

          {import.meta.env.DEV && (
            <pre className={styles.details}>{String(this.state.error?.stack ?? this.state.error)}</pre>
          )}
        </div>
      </div>
    );
  }
}
